/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Promo_Leagues_CountInputs */



/**
* | output |
* | --- |
* | "{count} league(s)" |
*
* @param {Promo_Leagues_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_leagues_count = /** @type {((inputs: Promo_Leagues_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Leagues_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} ligue(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} liga(s)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} liga(s)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} campionato/i`)
	return /** @type {LocalizedString} */ (`${i?.count} league(s)`)
});